import { Component } from '@angular/core';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';
import {
  KPI_PANEL_IMPORTS,
  StatusKpiPanelComponent,
} from '../../../../../panels/components/kpi/status-kpi-panel/status-kpi-panel.component';
import { PanelComponent } from '../../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../../panels/components/kpi/status-kpi-panel/status-kpi-panel.component.html',
  styleUrl: '../../../../../panels/components/kpi/status-kpi-panel/status-kpi-panel.component.scss',
  selector: 'app-connectivity-status-kpi-panel',
  imports: KPI_PANEL_IMPORTS,
})
export class ConnectivityStatusKpiPanelComponent extends StatusKpiPanelComponent {
  public static override readonly type = PanelType.ConnectivityStatusKpi;
  public override title = 'Status';
  public override icon = 'bi-cloud-check-fill';
  public override unit = DisplayUnit.None;
  public override color = Color.DarkBlue;
}
